export function validateEpisodeShareResult(result) {
    if (!result?.ok) return result;
    const token = String(result.token || "").trim();
    const shareUrl = String(result.share_url || "").trim();
    const queryIndex = shareUrl.indexOf("?");
    const hashToken = queryIndex >= 0
        ? String(new URLSearchParams(shareUrl.slice(queryIndex + 1)).get("token") || "").trim()
        : "";
    if (!token || !shareUrl || hashToken !== token) {
        return {
            ...result,
            ok: false,
            message: "The share link was created without a valid token. Please try again.",
        };
    }
    return result;
}
